export default "__VITE_ASSET__Da9nH_sv__"